import type { ProductRankingRow, Provenance } from '@losan/core';
import { DemoBadge } from './DemoBadge.js';

const eurFmt = new Intl.NumberFormat('es-ES', { style: 'currency', currency: 'EUR', maximumFractionDigits: 0 });
const intFmt = new Intl.NumberFormat('es-ES', { maximumFractionDigits: 0 });
const pctFmt = new Intl.NumberFormat('es-ES', { style: 'percent', maximumFractionDigits: 1, signDisplay: 'exceptZero' });

interface Props {
  rows: ProductRankingRow[];
  provenance: Provenance;
}

export function ProductRankingTable({ rows, provenance }: Props) {
  if (rows.length === 0) {
    return (
      <div className="section ranking">
        <h2>Top categorías <DemoBadge provenance={provenance} /></h2>
        <div className="empty-hint">No hay ventas que mostrar con los filtros actuales.</div>
      </div>
    );
  }
  return (
    <div className="section ranking">
      <h2>Top categorías <DemoBadge provenance={provenance} /></h2>
      <div className="ranking-table-wrap">
        <table className="ranking-table">
          <thead>
            <tr>
              <th>#</th>
              <th>Categoría</th>
              <th className="num">Facturación</th>
              <th className="num">Unidades</th>
              <th className="num">Share</th>
              <th className="num">vs LY</th>
            </tr>
          </thead>
          <tbody>
            {rows.map((r, i) => (
              <tr key={r.category}>
                <td className="rank">{i + 1}</td>
                <td className="name">{r.category || '—'}</td>
                <td className="num strong">{eurFmt.format(r.revenueEUR)}</td>
                <td className="num">{intFmt.format(r.units)}</td>
                <td className="num">{Math.round(r.share * 1000) / 10}%</td>
                <td className={`num ${r.yoyPct >= 0 ? 'pos' : 'neg'}`}>
                  {Number.isFinite(r.yoyPct) ? pctFmt.format(r.yoyPct) : 'nuevo'}
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
}
